import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COMPANY } from "@/lib/site";
import Reveal from "@/components/Reveal";

const VALUES = [
  { title: "Reliability", text: "We show up, we follow through, and we keep your systems running." },
  { title: "Local Expertise", text: "Rooted in Baton Rouge, we understand the businesses we serve." },
  { title: "Straight Talk", text: "No jargon, no surprises — clear advice and honest recommendations." },
  { title: "End-to-End", text: "From the first cable to the last update, we handle it all." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Sticky left */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B4513]">About Us</span>
              <h1 className="font-heading text-4xl md:text-6xl tracking-tight mt-4 leading-none">
                <span className="font-light">The team behind</span>{" "}
                <span className="font-black">Beta-Tech.</span>
              </h1>
              <img src={COMPANY.logo} alt={COMPANY.name} className="h-24 w-24 object-contain mt-8" />
            </div>
          </div>

          {/* Scrolling right */}
          <div className="lg:col-span-8 space-y-8 text-lg text-[#594A42] leading-relaxed">
            <Reveal>
              <p>
                <span className="font-heading font-black text-[#1A110B] text-2xl">Beta-Tech Systems, Inc.</span>{" "}
                is a Baton Rouge–based IT service and support company dedicated to keeping local
                businesses connected, secure, and productive.
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <p>
                We provide the provisioning, installation, and servicing of firewalls, networks,
                WiFi, telephone systems, surveillance systems, and complete computer and server
                support. Whether you're setting up a new office or maintaining an established
                operation, we deliver technology solutions that fit the way you work.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p>
                Our approach is simple: understand your business, recommend what actually helps,
                and stand behind our work with responsive local support. When something needs
                attention, you get a real team that knows your setup — not a distant call center.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#E5E1DE] border border-[#E5E1DE] mt-6">
                {VALUES.map((v) => (
                  <div key={v.title} className="bg-[#FAFAFA] p-8">
                    <h3 className="font-heading font-bold text-xl text-[#1A110B]">{v.title}</h3>
                    <p className="mt-3 text-base">{v.text}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <Link
                to="/contact"
                data-testid="about-cta"
                className="inline-flex items-center gap-2 bg-[#1A110B] text-white font-heading font-bold tracking-wider uppercase text-sm px-8 py-4 rounded-sm hover:bg-[#2E1605] transition-colors mt-4"
              >
                Work with us <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
